import { Loader } from "../../../components/core/Loader/Loader";
import { StyledCollaboratorCards } from "./CollaboratorProfileCards.styled";
import { CollaboratorCard } from "../../../components/CollaboratorProfileCard/CollaboratorCard/CollaboratorCard";
import { GoalsCard } from "../../../components/CollaboratorProfileCard/GoalsCard/GoalsCard";
import { FormationCard } from "../../../components/CollaboratorProfileCard/FormationCard/FormationCard";
import {
  CollaboratorAdvancement,
  CollaboratorCmSheet,
  CollaboratorDetails,
} from "../../../types/api/collaborators.type";
import { useGoalsCardVisibility } from "../../../hooks/useCollaboratorProfileCards.hook";
import { isProd, isQA } from "../../../utils/generals.utils";
type CollaboratorProfileCardsProps = {
  expanded: boolean;
  isInterim: boolean;
  isMyProfile?: boolean;
  collaborator: CollaboratorDetails;
  currentCmSheet?: CollaboratorCmSheet;
  collaboratorAdvancement: CollaboratorAdvancement | null;
  loading: boolean;
};

export const CollaboratorProfileCards = ({
  isInterim,
  expanded,
  isMyProfile,
  collaborator,
  currentCmSheet,
  collaboratorAdvancement,
  loading,
}: CollaboratorProfileCardsProps) => {
  const profileId = collaborator.id;

  const {
    data: goalsCardIsVisibleData,
    isFetching: goalsCardIsVisibleLoading,
  } = useGoalsCardVisibility({ profileId, isMyProfile, currentCmSheet });
  return (
    <Loader loading={loading || goalsCardIsVisibleLoading}>
      <StyledCollaboratorCards $expanded={expanded}>
        <CollaboratorCard
          collaboratorId={profileId}
          anagraphic={collaboratorAdvancement?.anagraphic ?? null}
          isInterim={isInterim}
        />
        {goalsCardIsVisibleData && (
          <GoalsCard
            achievement={collaboratorAdvancement?.achievements || []}
          />
        )}
        {currentCmSheet && !isProd() && !isQA() && (
          <FormationCard training={collaboratorAdvancement?.training || []} />
        )}
      </StyledCollaboratorCards>
    </Loader>
  );
};
